import { ComponentType } from 'react'
import { FiArchive, FiEdit2, FiPlay, FiRefreshCw, FiSlash, FiTrash2, FiX, FiZap } from 'react-icons/fi'

/* ----------------------------------------
 * ACTION CONSTANTS
 * ------------------------------------- */

export const UnitActivationAction = {
  activateNow: 'now',
  retryNow: 'retry-now',
  powerUp: 'power-up',
  retryPowerUp: 'retry-power-up',
  edit: 'edit',
  delete: 'delete',
  archive: 'archive',
  cancel: 'cancel',
  terminate: 'terminate'
} as const

export type UnitActivationActionType = (typeof UnitActivationAction)[keyof typeof UnitActivationAction]

/* ----------------------------------------
 * ICON PROPS
 * ------------------------------------- */

export interface ActionIconProps {
  className?: string
}

/* ----------------------------------------
 * ANIMATED ICON WRAPPER
 * ------------------------------------- */

const SpinningIcon =
  (Icon: ComponentType<ActionIconProps>) =>
  ({ className }: ActionIconProps) => <Icon className={`animate-spin ${className ?? ''}`} />

/* ----------------------------------------
 * ACTION → ICON MAP
 * ------------------------------------- */

export const UnitActivationActionIcons: Record<UnitActivationActionType, ComponentType<ActionIconProps>> = {
  now: FiPlay,

  'retry-now': SpinningIcon(FiRefreshCw),

  'power-up': FiZap,

  'retry-power-up': SpinningIcon(FiZap),

  edit: FiEdit2,

  delete: FiTrash2,

  archive: FiArchive,

  cancel: FiX,

  // Force stop / kill / terminate
  terminate: FiSlash
}

/* ----------------------------------------
 * HELPER (RECOMMENDED API)
 * ------------------------------------- */

export const getUnitActivationActionIcon = (action: UnitActivationActionType): ComponentType<ActionIconProps> => {
  return UnitActivationActionIcons[action]
}
